'use strict';
/**
 * Shared campaign status helpers used by both the Campaigns list page and its tests.
 * Kept dependency-free (no React Query types) so it can be unit-tested in isolation.
 */

// campaigns.status is a free-text column; the server only ever writes these values
// (see server/services/campaign-executor.ts and server/services/campaign-scheduler.ts).
export const CAMPAIGN_FINISHED_SUCCESS_STATUS = "completed";
export const CAMPAIGN_FINISHED_FAILURE_STATUSES = ["failed", "cancelled"];

export function isFinishedCampaignStatus(status: string): boolean {
  return status === CAMPAIGN_FINISHED_SUCCESS_STATUS || CAMPAIGN_FINISHED_FAILURE_STATUSES.includes(status);
}

/**
 * Whether the Campaigns list page's `["/api/campaigns"]` query should keep polling. The list
 * only ever updates on its own if at least one campaign is actively running - once none are,
 * further polling would just hit the server on a fixed cadence for no reason.
 */
export function campaignListNeedsPolling(campaigns: Array<{ status: string }>): boolean {
  return campaigns.some((c) => c.status === "running");
}
